import { PermissionService } from '../../../services/permission.service';

import { Component, EventEmitter, OnInit, Output, HostBinding } from '@angular/core';
import { AuthService } from '../../../authentication/auth.service';
import { SidebarMenuGroup, UserRole } from '../../models/common.model';
import { MENU_GROUPS, sidebarPermissionCode } from '../../navigation';
import { SettingsService } from '../../../settings/settings.service';
import { User } from '../../../authentication/auth.models';
import { isAdminUser } from '../../../utils';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @Output() toggleSidebarEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() collapsedChange = new EventEmitter<boolean>();

  @HostBinding('class.sidebar-collapsed') isCollapsed = false;

  userDesignation: string | null = null;
  currentUser: User | null = null;

  /** Rebuilt only when the profile changes, not on every change-detection pass. */
  protected menuGroups: SidebarMenuGroup[] = [];

  constructor(
    private _authService: AuthService,
    private settingsService: SettingsService,
    private _permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.settingsService.currentUser$.subscribe((user: User | null) => {
      this.currentUser = user;

      if (user) {
        this.userDesignation = this.getUserRoleOrDesignation(user);
      }

      this.menuGroups = this.buildMenuGroups();
    });
  }

  private buildMenuGroups(): SidebarMenuGroup[] {
    const filteredGroups: SidebarMenuGroup[] = [];

    for (const group of MENU_GROUPS) {
      const filteredItems = group.items.filter(item =>
        item.adminOnly
          ? isAdminUser(this.currentUser)
          : this._permissionService.hasPermission(sidebarPermissionCode(item))
      );

      if (filteredItems.length > 0) {
        filteredGroups.push({ ...group, items: filteredItems });
      }
    }

    return filteredGroups;
  }

  protected onLogout(): void {
    this._authService.logout();
  }

  protected toggleSidebar(): void {
    this.toggleSidebarEvent.emit();
  }

  protected toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }

  private getUserRoleOrDesignation(user: User): string {
    if (user.role === UserRole.ADMIN) {
      return UserRole.ADMIN;
    }

    return user?.employee?.designation?.title || 'Employee';
  }
}
